export default __webpack_public_path__ + "images/942de45acdbb6d571e441e906c091923.svg";